(function(){
  function onReady(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }

  function parseVariantDateTime(title){
    // Expect title starting "YYYY-MM-DD HH:MM"
    var m = title.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);
    if(!m) return null;
    return { date: m[1], time: m[2] };
  }

  onReady(function(){
    var script = document.currentScript;
    var sectionId = script && script.getAttribute('data-section');
    if(!sectionId) return;

    var root = document.getElementById('event-calendar-' + sectionId);
    if(!root) return;

    var variantSelect = root.querySelector('#VariantId-' + sectionId);
    var dateInput = root.querySelector('#EventDate-' + sectionId);
    var timeWrap = root.querySelector('#TimeSlots-' + sectionId);
    var seatsLeftEl = root.querySelector('#SeatsLeft-' + sectionId);
    var seatsCountEl = seatsLeftEl && seatsLeftEl.querySelector('.seats-count');
    var qtyInput = root.querySelector('#Quantity-' + sectionId);
    var submitBtn = root.querySelector('button[name="add"]');
    var propDate = root.querySelector('#PropDate-' + sectionId);
    var propTime = root.querySelector('#PropTime-' + sectionId);
    var qtyWrapper = root.querySelector('quantity-input');
    var maxPerCustomer = parseInt(qtyWrapper && qtyWrapper.getAttribute('data-max') || '6', 10);

    // Build an index: date -> [{time, id, inventory, title}]
    var slotsByDate = {};
    Array.prototype.forEach.call(variantSelect.options, function(opt){
      var meta = parseVariantDateTime(opt.getAttribute('data-title') || opt.textContent || '');
      if(!meta) return;
      var inv = parseInt(opt.getAttribute('data-inventory') || '0', 10);
      if(!slotsByDate[meta.date]) slotsByDate[meta.date] = [];
      slotsByDate[meta.date].push({
        time: meta.time,
        id: opt.value,
        inventory: inv,
        title: opt.getAttribute('data-title')
      });
    });

    // When date changes, show times for that date
    function renderTimes(dateStr){
      timeWrap.innerHTML = '';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Choose a time';
      seatsLeftEl.hidden = true;
      propDate.value = dateStr;
      propTime.value = '';

      var slots = slotsByDate[dateStr] || [];
      // sort by time
      slots.sort(function(a,b){ return a.time.localeCompare(b.time); });

      if(slots.length === 0){
        var empty = document.createElement('div');
        empty.className = 'no-slots';
        empty.textContent = 'No sessions on this date.';
        timeWrap.appendChild(empty);
        return;
      }

      slots.forEach(function(slot){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'time-slot';
        btn.textContent = slot.time + (slot.inventory > 0 ? ' ('+slot.inventory+' left)' : ' – Sold out');
        if(slot.inventory <= 0){ btn.disabled = true; btn.classList.add('sold-out'); }
        btn.addEventListener('click', function(){
          // Select hidden variant
          variantSelect.value = slot.id;
          // Seats left
          seatsCountEl.textContent = slot.inventory;
          seatsLeftEl.hidden = false;
          // Clamp qty
          var hardMax = Math.max(1, Math.min(maxPerCustomer, slot.inventory));
          qtyInput.value = Math.min(parseInt(qtyInput.value || '1', 10), hardMax);
          qtyInput.setAttribute('max', hardMax);
          // Enable submit
          submitBtn.disabled = false;
          submitBtn.textContent = 'Reserve seat(s)';
          // Store properties
          propDate.value = dateStr;
          propTime.value = slot.time;
        });
        timeWrap.appendChild(btn);
      });
    }

    if(dateInput){
      dateInput.addEventListener('change', function(){
        renderTimes(this.value);
      });
    }

    // If there is a slot today, preselect date
    var today = (new Date());
    var yyyy = today.getFullYear();
    var mm = ('0'+(today.getMonth()+1)).slice(-2);
    var dd = ('0'+today.getDate()).slice(-2);
    var todayStr = yyyy+'-'+mm+'-'+dd;
    if(slotsByDate[todayStr]){
      dateInput.value = todayStr;
      renderTimes(todayStr);
    }
  });
})();